import Layout from '@/layout'
const asyncPurchaseSettingRoutes = {
  path: '/purchase/setting',
  component: Layout,
  redirect: 'noRedirect',
  name: '审批设置',
  funcPerms: 'system:setting',
  meta: {
    title: '设置',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/setting/planCategory',
      component: () => import('@/views/purchase/planCategory/index'),
      name: '采购类型',
      funcPerms: 'system:setting:planCategory',
      meta: {
        title: '采购类型',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/itemCategory',
      component: () => import('@/views/purchase/itemCategory/index'),
      name: '物品类别',
      funcPerms: 'system:setting:itemCategory',
      meta: {
        title: '物品类别',
        icon: '',
        affix: false,
        noCache: false
      }
    },

    {
      path: '/purchase/setting/professional',
      component: () => import('@/views/purchase/expertManagement/index.vue'),
      name: '专家库',
      funcPerms: 'system:setting:professional',
      meta: {
        title: '专家库',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/professional/add',
      component: () => import('@/views/purchase/expertManagement/add.vue'),
      name: 'professionalAdd',
      hidden: true,
      funcPerms: 'system:setting:professional',
      meta: {
        title: '新增专家库',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/apply/group/100001',
      component: () => import('@/views/flowable/group/member-org.vue'),
      name: '三人审核人员',
      funcPerms: 'system:setting:apply:groupSr',
      meta: {
        title: '三人审核人员',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/apply/group/100002',
      component: () => import('@/views/flowable/group/member-org.vue'),
      name: '总务审核人员',
      funcPerms: 'system:setting:apply:groupZw',
      meta: {
        title: '总务审核人员',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/apply/group/100003',
      component: () => import('@/views/flowable/group/member-org.vue'),
      name: '财务审核人员',
      funcPerms: 'system:setting:apply:groupCw',
      meta: {
        title: '财务审核人员',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/apply/group/100004',
      component: () => import('@/views/flowable/group/member-org.vue'),
      name: '行政办公审核',
      funcPerms: 'system:setting:apply:groupXz',
      meta: {
        title: '行政办会审核人员',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/setting/apply/group/100005',
      component: () => import('@/views/flowable/group/member-org.vue'),
      name: '党委会审核人员',
      funcPerms: 'system:setting:apply:groupDwh',
      meta: {
        title: '党委会审核人员',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncPurchaseSettingRoutes
